import React, {useState} from "react";
import {useHistory} from "react-router";
import {RoutePaths} from "../../shared/routePaths";
import DisplayEventCatalogue from "./bits/displayEventCatalogue";
import {Navigation} from "../../utils/navigation";

export enum EventCatalogueBits {
  DisplayCatalogue
}

// No great way to test setActiveBit
/* istanbul ignore file */
const EventCatalogue: React.FC = () => {
  const history = useHistory();

  const [activeBit, setActiveBit] = useState(
    EventCatalogueBits.DisplayCatalogue
  );

  history.listen(() => {
    //Any time navigation happens in the app reset view
    setActiveBit(EventCatalogueBits.DisplayCatalogue);
  });

  const getActiveBit = () => {
    switch (activeBit) {
      case EventCatalogueBits.DisplayCatalogue:
        return (
          <DisplayEventCatalogue
            switchToAddNewTemplate={() =>
              Navigation.go(history, RoutePaths.CreateEventTemplate)
            }
            switchToEditTemplate={(eventTemplateId: string) => {
              Navigation.go(
                history,
                `${RoutePaths.EventTemplates}/${eventTemplateId}`
              );
            }}
          />
        );
    }
  };

  return getActiveBit();
};

export default EventCatalogue;
